import { render } from "./009-GlobalPitch2024.vue?vue&type=template&id=44578dab&scoped=true"
import script from "./009-GlobalPitch2024.vue?vue&type=script&lang=js"
export * from "./009-GlobalPitch2024.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=44578dab&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44578dab"]])

export default __exports__